import { ExperienceResource } from '../../../../../Types';
import { ShowUnlicensedToggle } from '../../ExperienceCatalog/Types';
import ProductType from './ProductType';
import ProductTypeLock from './ProductType/ProductTypeLock';

interface Props {
  showLockIcon: ShowUnlicensedToggle;
  experienceResource: ExperienceResource;
}
function ProductTypeChip({ showLockIcon, experienceResource }: Props) {
  switch (showLockIcon) {
    case 'hide':
      return <ProductType experienceResource={experienceResource} />;
    case 'show':
      return <ProductTypeLock experienceResource={experienceResource} />;
  }
}

export default ProductTypeChip;
